(function () {
  const sections = document.querySelectorAll('[data-plan-section]');
  if (!sections.length) return;

  sections.forEach((root) => {
    function normalizeGerman(value) {
      return String(value || '')
        .replace(/Ae/g, 'Ä')
        .replace(/Oe/g, 'Ö')
        .replace(/Ue/g, 'Ü')
        .replace(/ae/g, 'ä')
        .replace(/oe/g, 'ö')
        .replace(/ue/g, 'ü');
    }

    function normalizeSectionText(node) {
      const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
      const textNodes = [];

      while (walker.nextNode()) {
        textNodes.push(walker.currentNode);
      }

      textNodes.forEach((textNode) => {
        if (!textNode.nodeValue || !textNode.nodeValue.trim()) return;
        textNode.nodeValue = normalizeGerman(textNode.nodeValue);
      });

      node.querySelectorAll('[placeholder]').forEach((el) => {
        el.setAttribute('placeholder', normalizeGerman(el.getAttribute('placeholder')));
      });

      node.querySelectorAll('option').forEach((option) => {
        option.textContent = normalizeGerman(option.textContent);
        option.value = normalizeGerman(option.value);
      });
    }

    normalizeSectionText(root);

    const data = (name) => normalizeGerman(root.getAttribute('data-' + name));
    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, i) => {
          if (!entry.isIntersecting) return;
          setTimeout(() => entry.target.classList.add('on'), i * 65);
          revealObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -50px 0px' }
    );

    root.querySelectorAll('.r, .rl, .rr, .rs').forEach((el) => revealObserver.observe(el));

    const body = root.querySelector('[data-plan-body]');
    const tabs = root.querySelectorAll('[data-plan-week]');
    const days = Array.from(root.querySelectorAll('.fp-table thead th')).slice(1).map((th) => th.textContent.trim());
    const meals = [
      { name: data('meal-1-name') || 'Frühstück', time: data('meal-1-time') || '6-10 Uhr' },
      { name: data('meal-2-name') || 'Mittagessen', time: data('meal-2-time') || '12-13 Uhr' },
      { name: data('meal-3-name') || 'Abendessen', time: data('meal-3-time') || '18-20 Uhr' }
    ];
    const weekData = [
      [data('week-1-meal-1'), data('week-1-meal-2'), data('week-1-meal-3')],
      [data('week-2-meal-1'), data('week-2-meal-2'), data('week-2-meal-3')],
      [data('week-3-meal-1'), data('week-3-meal-2'), data('week-3-meal-3')],
      [data('week-4-meal-1'), data('week-4-meal-2'), data('week-4-meal-3')]
    ];

    function splitFood(text) {
      const parts = String(text || '').trim().split(/\s+/).filter(Boolean);
      if (!parts.length) return { amount: '-', food: '' };
      return {
        amount: parts[0],
        food: parts.slice(1).join(' ')
      };
    }

    function escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function renderWeek(index) {
      if (!body) return;
      const foods = weekData[index] || weekData[0];
      body.innerHTML = meals
        .map((meal, mealIndex) => {
          const parsed = splitFood(foods[mealIndex]);
          const dayCells = days
            .map(() => (
              '<td><div class="meal-chip">' +
              '<span class="mc-amount">' + escapeHtml(parsed.amount) + '</span>' +
              '<span class="mc-food">' + escapeHtml(parsed.food) + '</span>' +
              '</div></td>'
            ))
            .join('');

          return (
            '<tr>' +
            '<td><div class="time-label">' +
            '<span class="tl-name">' + escapeHtml(meal.name) + '</span>' +
            '<span class="tl-time">' + escapeHtml(meal.time) + '</span>' +
            '</div></td>' +
            dayCells +
            '</tr>'
          );
        })
        .join('');
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((item) => item.classList.remove('active'));
        tab.classList.add('active');
        renderWeek(Number(tab.dataset.planWeek || 1) - 1);
      });
    });

    renderWeek(0);

    const counter = root.querySelector('[data-plan-counter]');
    const target = Number(data('stat-target') || 12);
    if (counter) {
      const countObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            let value = 0;
            const step = Math.max(1, Math.ceil(target / 24));
            const timer = setInterval(() => {
              value = Math.min(target, value + step);
              counter.textContent = value;
              if (value >= target) clearInterval(timer);
            }, 70);
            countObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.5 }
      );
      countObserver.observe(counter);
    }
  });
})();
